import Block from '@components/block';
import { FC } from 'react';
import styles from './index.module.scss';

const VaultLoading: FC = () => {
  const data = [];
  for (let i = 0; i < 1; i++) {
    data.push('');
  }
  return (
    <>
      {data.map((_, index) => (
        <div key={index}>
          <div className={`${styles.table_td} ${styles.table_td_not}`}>
            <div className={styles.flex_left}>
              <Block height={24} width={'80%'} />
            </div>
            <div className={styles.flex_center}>
              <Block height={24} width={90} />
            </div>
            <div className={styles.flex_center}>
              <Block height={24} />
            </div>
            <div className={styles.flex_center}>
              <Block height={24} width={60} />
            </div>
            <div className={styles.flex_center}>
              <Block height={24} width={'60%'} />
            </div>
            <div className={styles.flex_right}>
              <Block height={32} width={90} />
            </div>
          </div>

          <div className={styles.mobile_loading}>
            <Block height={24} width={180} />
            <div className={styles.mobile_line}>
              <Block height={14} width={30} />
              <Block height={16} />
            </div>
            <div className={styles.mobile_line}>
              <Block height={14} width={30} />
              <Block height={16} />
            </div>
            <div className={styles.mobile_line}>
              <Block height={14} width={60} />
              <Block height={24} />
            </div>
            <div className={styles.mobile_line}>
              <Block height={14} />
              <Block height={16} width={70} />
            </div>
            <div className={styles.mobile_line}>
              <Block height={32} fullWidth />
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default VaultLoading;
